<!-- component to display In Person Logs, Progress Reports, Evaluation Documents, Assessments -->
<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="2" :class="isMobile ? null : 'pt-4'">
        <download-zip-button
          :selectedFiles="selectedItems.map((item) => item.fileId)"
          :zipFileName="zipFileName"
          @clear="clearSelected"
        ></download-zip-button
      ></v-col>
      <slot name="toggle"></slot>
      <slot
        name="actionButton"
        :selectedItems="selectedItems"
        :clearSelected="clearSelected"
      ></slot>
    </v-row>
    <v-data-table
      v-model="selectedItems"
      :headers="headers"
      :items="items"
      item-key="key"
      :search="search"
      @click:row="loadFile"
      dense
      height="100%"
      style="cursor: pointer"
      :item-class="highlightSelectedRow"
      show-select
      :key="items.length"
      :group-by="groupBy"
      :group-desc="groupDesc"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
    >
      <template v-slot:[`header.data-table-select`]></template>
      <template
        v-slot:[`group.header`]="{ group, headers, toggle, isOpen, items }"
        ><td :colspan="headers.length">
          <v-btn @click="toggle" x-small icon :ref="group">
            <v-icon v-if="isOpen">mdi-minus</v-icon>
            <v-icon v-else>mdi-plus</v-icon>
          </v-btn>
          <span class="mx-5 font-weight-bold text-subtitle-2">
            {{ items[0][groupName] }}
          </span>
        </td>
      </template>
      <template v-slot:[`item.sentToServiceCoordinator`]="{ item }">
        <slot name="checkbox" :item="item"></slot
      ></template>
      <template v-slot:[`item.scSignatureId`]="{ item }"
        ><slot name="checkbox" :item="item"></slot>
      </template>
      <template v-slot:[`item.supervisorSignatureId`]="{ item }"
        ><slot name="checkbox" :item="item"></slot
      ></template>
      <template v-slot:[`item.actions`]="{ item }">
        <slot name="actions" :item="item"></slot>
      </template>
    </v-data-table>
    <v-dialog
      v-if="selected && canPreview"
      v-model="dialog"
      width="1000"
      :scrollable="false"
    >
      <v-card width="100vw" height="80vh">
        <slot
          name="signature"
          :selectedItem="selected"
          :loadFile="loadFile"
        ></slot>
        <slot name="loading"></slot>
        <iframe width="100%" height="100%" :src="url"></iframe>
      </v-card>
    </v-dialog>
    <v-dialog v-if="selected && !canPreview" v-model="dialog" width="400">
      <v-card>
        <v-card-title class="d-flex align-center justify-center">
          <v-subheader class="text-h5">Preview not available</v-subheader>
        </v-card-title>
        <v-card-text class="d-flex align-center justify-center">
          <v-btn
            @click="downloadFile"
            class="text-decoration-underline"
            color="primary"
            text
            >Click Here to Download</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DownloadZipButton from "../../Shared/download-zip-btn";
import { downloadFileUrl } from "../../../utils/download-utils";

export default {
  components: { DownloadZipButton },
  props: [
    "headers",
    "items",
    "zipFileName",
    "groupName",
    "groupBy",
    "groupDesc",
    "sortBy",
    "sortDesc",
  ],
  data() {
    return {
      search: "",
      url: "",
      selected: null,
      selectedItems: [],
      dialog: false,
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    canPreview() {
      var lastIndex = this.selected.fileName.lastIndexOf(".");
      var fileExtension = this.selected.fileName.slice(lastIndex);
      var previewableExtensions = [".pdf", ".png", ".jpg"];
      return previewableExtensions.includes(fileExtension);
    },
  },
  methods: {
    async loadFile(item) {
      this.url = null;
      this.selected = item;
      var fileUrl = await this.$store.dispatch("filesModule/getFileUrl", {
        fileId: item.fileId,
      });
      this.url = fileUrl;
      this.dialog = true;
    },
    highlightSelectedRow: function (row) {
      return this.selected?.key === row.key && "selectedRow";
    },
    clearSelected() {
      this.selectedItems = [];
    },
    downloadFile: async function () {
      await downloadFileUrl(this.url, this.selected.fileName);
    },
  },
  watch: {
    items() {
      this.selected = null;
    },
  },
};
</script>

<style lang="css">
.selectedRow {
  background: #ccc;
}
</style>